<template>
  <div class="student-detail">
    <div class="header-bar">
      <span class="page-title">个人学习详情</span>
      <el-select
        v-model="selectedUserId"
        clearable
        placeholder="请选择学员"
        @change="onStudentChange"
      >
        <el-option
          v-for="item in studentOptions"
          :key="item.userId"
          :label="`${item.studentName}（${item.phone}）`"
          :value="item.userId"
        ></el-option>
      </el-select>
      <el-button type="primary" style="margin-left: 12px" @click="handleSearch">
        查找
      </el-button>
      <el-button style="margin-left: 8px" @click="handleReset">重置</el-button>
    </div>

    <el-tabs v-model="activeTab" type="border-card" @tab-click="handleTabClick">
      <el-tab-pane label="课程学习统计" name="course">
        <div class="filter-bar">
          <div class="filter-left">
            <div class="filter-item">
              <span class="filter-label">课程筛选</span>
              <el-select
                v-model="selectedCourseId"
                clearable
                placeholder="请选择课程"
                @change="onCourseChange"
              >
                <el-option
                  v-for="item in courseOptions"
                  :key="item.courseId"
                  :label="item.courseName"
                  :value="item.courseId"
                ></el-option>
              </el-select>
            </div>
          </div>
          <el-button type="primary" @click="handleExport">导出记录</el-button>
        </div>
        <table-list
          :loading="loading"
          :data="displayCourseList"
          :columns="courseColumns"
          :pager="coursePager"
          :options="{ selection: true }"
          @size-change="handleCourseSizeChange"
          @current-change="handleCourseCurrentChange"
        ></table-list>
      </el-tab-pane>
      <el-tab-pane label="章节学习轨迹记录" name="chapter">
        <div class="filter-bar">
          <div class="filter-left">
            <div class="filter-item">
              <span class="filter-label">课程筛选</span>
              <el-select
                v-model="selectedCourseId"
                clearable
                placeholder="请选择课程"
                @change="onCourseChange"
              >
                <el-option
                  v-for="item in courseOptions"
                  :key="item.courseId"
                  :label="item.courseName"
                  :value="item.courseId"
                ></el-option>
              </el-select>
            </div>
            <div class="filter-item">
              <span class="filter-label">章节筛选</span>
              <el-select
                v-model="selectedSectionId"
                clearable
                placeholder="请选择章节"
                @change="onSectionChange"
              >
                <el-option
                  v-for="item in sectionOptions"
                  :key="item.sectionId"
                  :label="item.sectionName"
                  :value="item.sectionId"
                ></el-option>
              </el-select>
            </div>
            <el-checkbox v-model="onlyLastRecordBySection" @change="onOnlyLastChange">
              只看每节最新的进度
            </el-checkbox>
          </div>
          <el-button type="primary" @click="handleExport">导出记录</el-button>
        </div>
        <table-list
          :loading="loading"
          :data="displayChapterList"
          :columns="chapterColumns"
          :pager="chapterPager"
          :options="{ selection: true }"
          @size-change="handleChapterSizeChange"
          @current-change="handleChapterCurrentChange"
        ></table-list>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
const courseColumns = [
  { prop: 'studentName', label: '学员名称', minWidth: 100 },
  { prop: 'phone', label: '手机号码', minWidth: 120 },
  { prop: 'courseName', label: '课程名称', minWidth: 180 },
  { prop: 'studyDuration', label: '已学时长', minWidth: 120 },
  { prop: 'courseDuration', label: '应学时长', minWidth: 120 },
  { prop: 'completedSectionCount', label: '已学章节数', minWidth: 100 },
  { prop: 'sectionTotal', label: '应学章节数', minWidth: 100 },
  { prop: 'progress', label: '学习进度', minWidth: 100 },
]

const chapterColumns = [
  { prop: 'studentName', label: '学员名称', minWidth: 100 },
  { prop: 'phone', label: '手机号码', minWidth: 120 },
  { prop: 'courseName', label: '课程名称', minWidth: 140 },
  { prop: 'sectionName', label: '章节名称', minWidth: 140 },
  { prop: 'beginTime', label: '学习片段开始时间', minWidth: 160 },
  { prop: 'endTime', label: '学习片段结束时间', minWidth: 160 },
  { prop: 'studyDuration', label: '学习时长', minWidth: 100 },
  { prop: 'studyDurationTotal', label: '累计观看时长', minWidth: 120 },
  { prop: 'sectionDuration', label: '视频总时长', minWidth: 120 },
  { prop: 'progress', label: '完成度', minWidth: 100 },
  { prop: 'studyCompletedTimeRange', label: '视频总完成时间段', minWidth: 180 },
]

import TableList from '@/components/TableList'
import to from 'await-to'
import {
  classCertInfo,
  classCertStudentSelectList,
  classCertCourseSelectList,
  classCertCourseStudyHistory,
  classCertCourseStudyHistoryExport,
  classCertCourseSectionStudyHistory,
  classCertCourseSectionStudyHistoryExport,
  courseSectionSelectList,
  courseProductStudyHistory,
  courseProductSectionStudyHistory,
  courseProductStudyHistoryExport,
  courseProductSectionStudyHistoryExport,
} from '@/api/certificate'

export default {
  name: 'TrainingManageStudentDetail',
  components: {
    TableList,
  },
  data() {
    return {
      courseColumns,
      chapterColumns,
      classInfo: {},
      studentOptions: [],
      courseOptions: [],
      sectionOptions: [],
      selectedUserId: '',
      selectedCourseId: '',
      selectedSectionId: '',
      realCourseId: '',
      onlyLastRecordBySection: false,
      activeTab: 'course',
      loading: false,
      courseAll: [],
      chapterAll: [],
      coursePager: { total: 0, size: 10, current: 1 },
      chapterPager: { total: 0, size: 10, current: 1 },
    }
  },
  computed: {
    classCertId() {
      return this.$route.params.classCertId
    },
    queryUserId() {
      return this.$route.query.userId
    },
    productId() {
      const id = this.$route.query.productId
      return id ? Number(id) : ''
    },
    courseName() {
      return this.$route.query.courseName || ''
    },
    queryCourseId() {
      const id = this.$route.query.courseId
      return id ? Number(id) : ''
    },
    queryStudentName() {
      return this.$route.query.studentName || ''
    },
    queryPhone() {
      return this.$route.query.phone || ''
    },
    isCourseProductMode() {
      const id = this.$route.params.classCertId
      const hasClassCertId = id !== '' && id !== undefined && id !== null
      return !hasClassCertId && !!this.productId
    },
    displayCourseList() {
      return this.courseAll
    },
    displayChapterList() {
      return this.chapterAll
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      if (this.isCourseProductMode) {
        this.initCourseProductMode()
        return
      }
      await this.getClassInfo()
      await Promise.all([this.getStudentOptions(), this.getCourseOptions()])
      if (this.queryUserId) {
        this.selectedUserId = Number(this.queryUserId)
        this.getCourseList()
      }
    },
    async initCourseProductMode() {
      if (this.queryUserId) {
        this.selectedUserId = Number(this.queryUserId)
        this.studentOptions = [
          {
            userId: Number(this.queryUserId),
            studentName: this.queryStudentName,
            phone: this.queryPhone,
          },
        ]
      }
      // 课程商品模式下用URL传入的课程信息构建课程下拉选项（仅回显，禁用切换）
      if (this.queryCourseId && this.courseName) {
        this.courseOptions = [{ courseId: this.queryCourseId, courseName: this.courseName }]
        this.selectedCourseId = this.queryCourseId
        this.realCourseId = this.queryCourseId
      }
      this.getCourseList()
    },
    async getClassInfo() {
      const [res, err] = await to(classCertInfo({ classCertId: this.classCertId }))
      if (err) return this.$message.warning(err.msg)
      this.classInfo = res.data
    },
    async getStudentOptions() {
      const [res, err] = await to(classCertStudentSelectList({ classCertId: this.classCertId }))
      if (err) return this.$message.warning(err.msg)
      this.studentOptions = res.data || []
    },
    async getCourseOptions() {
      const [res, err] = await to(classCertCourseSelectList({ classCertId: this.classCertId }))
      if (err) return this.$message.warning(err.msg)
      this.courseOptions = res.data || []
    },
    async getSectionOptions() {
      this.sectionOptions = []
      const courseId = this.isCourseProductMode ? this.realCourseId : this.selectedCourseId
      if (!courseId) return
      const [res, err] = await to(courseSectionSelectList({ courseId }))
      if (err) return this.$message.warning(err.msg)
      this.sectionOptions = res.data || []
    },
    async getCourseList() {
      this.courseAll = []
      this.coursePager.total = 0
      if (!this.selectedUserId) return

      this.loading = true
      const apiParams = {
        userId: this.selectedUserId,
        current: this.coursePager.current,
        size: this.coursePager.size,
      }
      if (!this.isCourseProductMode) {
        apiParams.classCertId = this.classCertId
        apiParams.courseId = this.selectedCourseId || undefined
      } else {
        apiParams.productId = this.productId
      }
      const api = this.isCourseProductMode ? courseProductStudyHistory : classCertCourseStudyHistory
      const [res, err] = await to(api(apiParams))
      this.loading = false
      if (err) return this.$message.warning(err.msg)

      this.courseAll = res.data.list.map(item => ({
        studentName: item.studentName,
        phone: item.phone,
        courseName: item.courseName,
        courseId: item.courseId,
        studyDuration: item.studyDuration || '00:00:00',
        courseDuration: item.courseDuration || '00:00:00',
        completedSectionCount: item.studySectionCount,
        sectionTotal: item.sectionCount,
        progress: item.progress,
      }))
      this.coursePager.total = res.data.total
    },
    async getChapterList() {
      this.chapterAll = []
      this.chapterPager.total = 0
      if (!this.selectedUserId) return

      this.loading = true
      const apiParams = {
        userId: this.selectedUserId,
        sectionId: this.selectedSectionId || undefined,
        onlyLastRecordBySection: this.onlyLastRecordBySection,
        current: this.chapterPager.current,
        size: this.chapterPager.size,
      }
      const api = this.isCourseProductMode
        ? courseProductSectionStudyHistory
        : classCertCourseSectionStudyHistory
      if (!this.isCourseProductMode) {
        apiParams.classCertId = this.classCertId
        apiParams.courseId = this.selectedCourseId || undefined
      } else {
        apiParams.productId = this.productId
      }
      const [res, err] = await to(api(apiParams))
      this.loading = false
      if (err) return this.$message.warning(err.msg)

      this.chapterAll = res.data.list.map(item => ({
        studentName: item.studentName,
        phone: item.phone,
        courseName: item.courseName,
        sectionName: item.sectionName,
        sectionId: item.sectionId,
        beginTime: item.beginTime,
        endTime: item.endTime,
        studyDuration: item.studyDuration || '00:00:00',
        studyDurationTotal: item.studyDurationTotal || '00:00:00',
        sectionDuration: item.sectionDuration || '00:00:00',
        progress: item.progress,
        studyCompletedTimeRange: item.studyCompletedTimeRange,
      }))
      this.chapterPager.total = res.data.total
    },
    onStudentChange() {
      this.coursePager.current = 1
      this.chapterPager.current = 1
      if (this.activeTab === 'course') {
        this.getCourseList()
      } else {
        this.getChapterList()
      }
    },
    onCourseChange() {
      this.coursePager.current = 1
      this.chapterPager.current = 1
      this.selectedSectionId = ''
      if (this.activeTab === 'course') {
        this.getCourseList()
      } else {
        this.getSectionOptions()
        this.getChapterList()
      }
    },
    onSectionChange() {
      this.chapterPager.current = 1
      this.getChapterList()
    },
    onOnlyLastChange() {
      this.chapterPager.current = 1
      this.getChapterList()
    },
    handleSearch() {
      this.coursePager.current = 1
      this.chapterPager.current = 1
      if (this.activeTab === 'course') {
        this.getCourseList()
      } else {
        this.getChapterList()
      }
    },
    handleReset() {
      if (this.isCourseProductMode) {
        this.selectedSectionId = ''
        this.onlyLastRecordBySection = false
        this.coursePager.current = 1
        this.chapterPager.current = 1
        this.getCourseList()
        return
      }
      this.selectedUserId = ''
      this.selectedCourseId = ''
      this.selectedSectionId = ''
      this.onlyLastRecordBySection = false
      this.coursePager.current = 1
      this.chapterPager.current = 1
      this.courseAll = []
      this.chapterAll = []
      this.coursePager.total = 0
      this.chapterPager.total = 0
    },
    async handleTabClick() {
      if (this.activeTab === 'course' && !this.courseAll.length) {
        await this.getCourseList()
      }
      if (this.activeTab === 'chapter') {
        this.getSectionOptions()
        if (!this.chapterAll.length) {
          this.getChapterList()
        }
      }
    },
    async handleExport() {
      if (!this.selectedUserId) return this.$message.warning('请先选择学员')
      const isChapter = this.activeTab === 'chapter'
      let exportApi, fileName, params

      if (this.isCourseProductMode) {
        if (isChapter) {
          exportApi = courseProductSectionStudyHistoryExport
          fileName = '课程商品章节学习记录导出.xlsx'
          params = {
            userId: this.selectedUserId,
            productId: this.productId,
            sectionId: this.selectedSectionId || undefined,
            onlyLastRecordBySection: this.onlyLastRecordBySection,
          }
        } else {
          exportApi = courseProductStudyHistoryExport
          fileName = '课程商品学习记录导出.xlsx'
          params = {
            userId: this.selectedUserId,
            productId: this.productId,
          }
        }
      } else {
        exportApi = isChapter
          ? classCertCourseSectionStudyHistoryExport
          : classCertCourseStudyHistoryExport
        fileName = isChapter ? '章节学习记录导出.xlsx' : '课程学习记录导出.xlsx'
        params = {
          classCertId: this.classCertId,
          userId: this.selectedUserId,
          courseId: this.selectedCourseId || undefined,
          sectionId: isChapter ? this.selectedSectionId || undefined : undefined,
          onlyLastRecordBySection: isChapter ? this.onlyLastRecordBySection : undefined,
        }
      }

      const [res, err] = await to(exportApi(params))
      if (err) return this.$message.warning(err.msg)
      const blob = new Blob([res], { type: 'application/vnd.ms-excel' })
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = fileName
      a.click()
      window.URL.revokeObjectURL(url)
    },
    handleBack() {
      this.$router.back()
    },
    handleCourseSizeChange(size) {
      this.coursePager.current = 1
      this.coursePager.size = size
      this.getCourseList()
    },
    handleCourseCurrentChange(current) {
      this.coursePager.current = current
      this.getCourseList()
    },
    handleChapterSizeChange(size) {
      this.chapterPager.current = 1
      this.chapterPager.size = size
      this.getChapterList()
    },
    handleChapterCurrentChange(current) {
      this.chapterPager.current = current
      this.getChapterList()
    },
  },
}
</script>

<style lang="scss" scoped>
.student-detail {
  padding: 20px;
  .header-bar {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    .page-title {
      font-size: 18px;
      font-weight: bold;
      color: #606266;
      margin-right: 24px;
    }
    .el-select {
      width: 220px;
    }
  }
  .filter-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
    .filter-left {
      display: flex;
      align-items: center;
      .filter-item {
        display: flex;
        align-items: center;
        margin-right: 16px;
        .filter-label {
          font-size: 14px;
          color: #606266;
          margin-right: 8px;
          white-space: nowrap;
        }
      }
      .el-checkbox {
        margin-left: 8px;
      }
    }
  }
}
</style>
